import styled from '@emotion/styled';

import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '../../../styles/emotion';

import { ButtonV3 } from '../../ButtonV3';
import ZolaTermsPrivacy from '../../AuthForms/components/ZolaTermsPrivacy';

export const Hed = styled.h1`
  color: var(--text-primary, ${COLORS3.BLACK_100});
  margin: 0 0 ${SPACING.XS};
  font-family: ${FONT.FAMILY.SANS_SERIF};
  ${FONT.textSizeCompact(FONT.SIZE.LARGER)};
  ${MEDIA_QUERY.MOBILE} {
    ${FONT.textSizeCompact(FONT.SIZE.LARGE)};
  }
`;

export const Dek = styled.p`
  color: var(--text-secondary, ${COLORS3.BLACK_075});
  margin: 0;
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
`;

export const StepContent = styled.div``;

export const Container = styled.div`
  padding-bottom: ${SPACING.LG};
  ${MEDIA_QUERY.MOBILE} {
    padding-bottom: 89px; // height of MobileFixedBtnContainer below
  }

  ${Hed}, ${Dek} {
    & + ${StepContent} {
      margin-top: ${SPACING.S32};
    }
  }
`;

export const AnimatedButtonWrapper = styled.div`
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    margin-top: ${SPACING.S32};
  }
`;

export const StyledSubmitButton = styled(ButtonV3)`
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    margin-top: ${SPACING.S32};
  }
`;

export const AllFieldsRequired = styled.div`
  text-align: right;
  color: var(--text-secondary, ${COLORS3.BLACK_075});
  ${FONT.textSizeCompact(FONT.SIZE.EXTRA_SMALL)}
`;

export const LoginCta = styled.div`
  margin-top: ${SPACING.LG};
  text-align: center;
`;

export const StyledTermsPrivacy = styled(ZolaTermsPrivacy)`
  padding-top: ${SPACING.S24};
  color: var(--text-secondary, ${COLORS3.BLACK_075});
  a {
    color: var(--text-secondary, ${COLORS3.BLACK_075});
    font-weight: ${FONT.WEIGHT.REGULAR};
  }
`;

export const MobileFixedBtnContainer = styled.div`
  ${MEDIA_QUERY.MOBILE} {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    right: 0;
    padding: ${SPACING.S16} ${SPACING.MD};
    background-color: var(--background-screen, ${COLORS3.WHITE_100});
    border-top: 1px solid ${COLORS3.BLACK_100};
  }
`;
